import React from 'react';

const Main = () => {
  return (
    <div>Welcome to Landing!</div>
  );
}

export default Main;